<template>
    <el-dialog
      title="配置可用区域"
      :visible.sync="connetPODialog" :before-close="handleConnectPODialogClose"
      top="8vh" >
      <div v-loading="loading">
      <div v-if="mappingList.length>0" class="select-item-box">
        <div :class="['select-item-line',(mappingList&&mappingList.length>0)?'select-item':'']">
          <div v-for="item of mappingList" :key='item.themeChannelCode' >
            <div :class="['display-flex',item.themeChannelCode===focusChannel.themeChannelCode?'focus-style':'']">
              <el-checkbox :indeterminate="item.isIndeterminate" v-model="item.isChecked" @change="(...val)=>handleChangeChannel(item,'focusChannel',...val)">{{item.themeChannelName}}
              </el-checkbox>
              <i class="el-icon-arrow-right icon-style" @click="handleClick(item,'focusChannel')"></i>
            </div>
          </div>
        </div>
        <div :class="['select-item-line',(focusChannel.themeStyles&&focusChannel.themeStyles.length>0)?'select-item':'']">
          <div v-for="style of focusChannel.themeStyles" :key="style.themeStyleCode">
            <div :class="['display-flex',style.themeStyleCode===focusStyle.themeStyleCode?'focus-style':'']">
              <el-checkbox :indeterminate="style.isIndeterminate" v-model="style.isChecked" @change="(...val)=>handleChangeStyle(style,'focusStyle',true,...val)">{{style.themeStyleName}}</el-checkbox>
              <i class="el-icon-arrow-right icon-style" @click="handleClick(style,'focusStyle')"></i>
            </div>
          </div>
        </div>
        <div v-if="focusLevel" :class="['select-item-line-level',(focusStyle.themeLevels&&focusStyle.themeLevels.length>0)?'select-item':'']">
            <div v-for="level of focusStyle.themeLevels" :key='level.themeLevelCode'>
              <div :class="['display-flex',level.themeLevelCode===focusLevel.themeLevelCode?'focus-style':'']">
                <el-checkbox :indeterminate="level.isIndeterminate" v-model="level.isChecked" @change="(...val)=>handleChangeLevel(level,'focusLevel',true,...val)">{{level.themeLevelName}}</el-checkbox>
                <i class="el-icon-arrow-right icon-style" @click="handleClick(level,'focusLevel')"></i>
              </div>
            </div>
        </div>
        <div v-if="focusLevel" :class="['select-item-line',(focusLevel.mappingBuList&&focusLevel.mappingBuList.length>0)?'select-item':'']">
            <div v-for="bu of focusLevel.mappingBuList" :key="bu.buCode">
              <div :class="['display-flex',bu.buCode===focusBU.buCode?'focus-style':'']">
                <el-checkbox :indeterminate="bu.isIndeterminate" v-model="bu.isChecked" @change="(...val)=>handleChangeBU(bu,'focusBU',true,...val)">{{getName(bu.buName)}}</el-checkbox>
                <i class="el-icon-arrow-right icon-style" @click="handleClick(bu,'focusBU')"></i>
              </div>
            </div>
        </div>
        <div v-else :class="['select-item-line',(focusStyle.mappingBuList&&focusStyle.mappingBuList.length>0)?'select-item':'']">
          <div v-for="bu of focusStyle.mappingBuList" :key="bu.buCode">
            <div :class="['display-flex',bu.buCode===focusBU.buCode?'focus-style':'']">
              <el-checkbox :indeterminate="bu.isIndeterminate" v-model="bu.isChecked" @change="(...val)=>handleChangeBU(bu,'focusBU',true,...val)">{{getName(bu.buName)}}</el-checkbox>
              <i class="el-icon-arrow-right icon-style" @click="handleClick(bu,'focusBU')"></i>
            </div>
          </div>
        </div>
        <div>
          <div v-for="region of focusBU.mappingRegionList" class="display-flex select-item-line" :key="region.regionCode" @click="handleClick(region,'focusRegion')">
              <el-checkbox v-model="region.isChecked" @change="(...val)=>handleChangeRegion(region,'focusRegion',...val)">{{getName(region.regionName)}}</el-checkbox>
          </div>
        </div>
      </div>
      <div v-else class="no-data">
        暂无可配置的区域
      </div>
      </div>

      <div slot="footer" class="dialog-footer">
        <el-button type="danger" size="small" :disabled="loading||mappingList.length==0" @click="handleSubmit">确认PO关联</el-button>
      </div>
    </el-dialog>
</template>

<script>
import gameplanApi from "@/api/gameplan";
export default {
  name: 'WorkspaceJsonMappingRegion',
  data() {
    return {
      themeId:'',
      vendorCode:'',
      loading:true,
      focusChannel:{},
      focusStyle:{},
      focusLevel:{},
      focusBU:{},
      focusRegion:{},
      connetPODialog:false,
      mappingList:[]
    };
  },
  watch:{
    focusChannel(){
      this.focusStyle = this.focusChannel.themeStyles&&this.focusChannel.themeStyles[0]||{}
    },
    focusLevel(nval,oval){
      if(nval&&oval){
        this.focusBU = this.focusLevel.mappingBuList&&this.focusLevel.mappingBuList[0] || {}
        this.focusRegion = this.focusBU.mappingRegionList&&this.focusBU.mappingRegionList[0] || {}
      }
    },
    focusStyle(){
      if(this.focusStyle.themeLevels&&this.focusStyle.themeLevels.length>0){
        this.focusLevel = this.focusStyle.themeLevels&&this.focusStyle.themeLevels[0] || {}
        this.focusBU = this.focusLevel.mappingBuList&&this.focusLevel.mappingBuList[0] || {}
      }else {
        this.focusLevel = null
        this.focusBU = this.focusStyle.mappingBuList&&this.focusStyle.mappingBuList[0] || {}
      }
      this.focusRegion = this.focusBU.mappingRegionList&&this.focusBU.mappingRegionList[0] || {}
    }
  },
  methods: {
    showInfo(themeId,vendorCode){
      this.loading = true
      this.connetPODialog = true
      this.themeId = themeId
      this.vendorCode = vendorCode
      this.getGameplanPRPOMapping()
    },
    async getGameplanPRPOMapping() {
      let params = {
        themeId:this.themeId,
        vendorCode:this.vendorCode,
      }
      const { data } = await gameplanApi.getGameplanPRPOMapping(params);
      if (data.resultCode === "0") {
        this.mappingList = data.resultData?.mappingList || [];
      }
      this.init()
    },
    init(){
      this.mappingList = this.mappingList.filter(channel=>{
        channel.themeStyles = channel.themeStyles&&channel.themeStyles.filter(style=>{
          let styleData = {}
          if(style.themeLevels&&style.themeLevels.length>0){
            style.themeLevels = style.themeLevels&&style.themeLevels.filter(level=>{
              level.mappingBuList = level.mappingBuList&&level.mappingBuList.filter(bu=>{
                bu.mappingRegionList = bu.mappingRegionList&&bu.mappingRegionList.filter(region=>{
                  this.$set(region,'isChecked',region.vendorCode===this.vendorCode)
                  return region.vendorCode===this.vendorCode||!region.vendorCode
                })
                if(!bu.mappingRegionList||bu.mappingRegionList.length===0) {
                  this.$set(bu,'isChecked',false)
                  this.$set(bu,'isIndeterminate',false)
                }
                else {
                  const data = this.getIndeterminateBU(bu,'mappingRegionList','init')
                  this.$set(bu,'isChecked',data.isChecked)
                  this.$set(bu,'isIndeterminate',data.isIndeterminate)
                }
                return bu.mappingRegionList.length!==0
              })
              const data = this.getIndeterminateLevel(level,'mappingBuList','init')
              this.$set(level,'isChecked',data.isChecked)
              this.$set(level,'isIndeterminate',data.isIndeterminate)
              return level.mappingBuList.length!==0
            })
            styleData = this.getIndeterminateStyle(style,'themeLevels','init')
            this.$set(style,'isChecked',styleData.isChecked)
            this.$set(style,'isIndeterminate',styleData.isIndeterminate)
            return style.themeLevels.length!==0
          }else{
            style.mappingBuList =  style.mappingBuList&&style.mappingBuList.filter(bu=>{
              bu.mappingRegionList = bu.mappingRegionList&&bu.mappingRegionList.filter(region=>{
                this.$set(region,'isChecked',region.vendorCode===this.vendorCode)
                return region.vendorCode===this.vendorCode||!region.vendorCode
              })
              if(bu.mappingRegionList&&bu.mappingRegionList.length>0){
                const data = this.getIndeterminateBU(bu,'mappingRegionList','init')
                this.$set(bu,'isChecked',data.isChecked)
                this.$set(bu,'isIndeterminate',data.isIndeterminate)
                return bu.mappingRegionList.length>0
              }else {
                this.$set(bu,'isChecked',false)
                this.$set(bu,'isIndeterminate',false)
                return bu.mappingRegionList.length>0
              }
            })
            styleData = this.getIndeterminateStyle(style,'mappingBuList','init')
            this.$set(style,'isChecked',styleData.isChecked)
            this.$set(style,'isIndeterminate',styleData.isIndeterminate)
            return style.mappingBuList.length!==0
          }
        })
        const data = this.getIndeterminateChannel(channel,'themeStyles')
        this.$set(channel,'isChecked',data.isChecked)
        this.$set(channel,'isIndeterminate',data.isIndeterminate)
        return channel.themeStyles.length!==0
      })
      this.focusChannel = this.mappingList[0] ||{}
      this.loading = false
    },
    handleClick(item,type){
      this[type] = item
    },
    handleChangeChannel(item,type,val){
      this[type] = item
      item.isIndeterminate = false
      item.themeStyles.forEach(style=>{
        this.handleChangeStyle(style,'focusStyle',false,val)
      })
    },
    handleChangeStyle(item,type,isClick,val){
      item.isChecked = val
      item.isIndeterminate = false
      if((!item.themeLevels||item.themeLevels.length===0)){
        item.mappingBuList.forEach(bu=>{
          this.handleChangeBU(bu,'foucsBU',false,val)
        })
      }else {
        item.themeLevels.forEach(level=>{
          this.handleChangeLevel(level,'focusLevel',false,val)
        })
      }
      if(isClick){
        this[type] = item
        this.getIndeterminateChannel(this.focusChannel,'themeStyles')
      }
    },
    handleChangeLevel(item,type,isClick,val){
      item.isChecked = val
      item.isIndeterminate = false
      item.mappingBuList.forEach(bu=>{
        this.handleChangeBU(bu,'foucsBU',false,val)
      })
      if(isClick){
        this[type] = item
        this.getIndeterminateStyle(this.focusStyle,'themeLevels')
      }
    },
    handleChangeBU(item,type,isClick,val){
      this.mappingList = Object.assign([],this.mappingList)
      item.isChecked = val
      item.isIndeterminate = false
      item.mappingRegionList.forEach(region=>{
        region.isChecked = val
      })
      if(isClick){
        this[type] = item
        if(!this.focusStyle.themeLevels||this.focusStyle.themeLevels.length===0){
          this.getIndeterminateStyle(this.focusStyle,'mappingBuList')
        }
        else this.getIndeterminateLevel(this.focusLevel,'mappingBuList')
      }
    },
    handleChangeRegion(item,type,val){
      this[type] = item
      this.getIndeterminateBU(this.focusBU)
    },
    getIndeterminateBU(bu,nextList,type){
      if(bu.mappingRegionList.length!==0){
        let regionCount = 0
        bu.mappingRegionList.forEach(region=>{
          if(region.isChecked) regionCount++
        })
        if(regionCount===0){
          bu.isChecked = false
          bu.isIndeterminate = false
        }else if(regionCount<bu.mappingRegionList.length) {
          bu.isChecked = true
          bu.isIndeterminate = true
        }else {
          bu.isChecked = true
          bu.isIndeterminate = false
        }
      }else {
        bu.isIndeterminate = false
      }
      if(type==='init'){
        return {
          isChecked:bu.isChecked,
          isIndeterminate:bu.isIndeterminate
        }
      }
      if(!this.focusStyle.themeLevels||this.focusStyle.themeLevels.length===0) this.getIndeterminateStyle(this.focusStyle,'mappingBuList')
      else this.getIndeterminateLevel(this.focusLevel,'mappingBuList')
    },
    getIndeterminateLevel(item,nextList,type){
      let checkedcount = 0
      let indeterminateCount = 0
      if(item[nextList]&&item[nextList].length>0){
        item[nextList].forEach(style=>{
          if(style.isChecked&&style.isIndeterminate) indeterminateCount++
          if(style.isChecked) checkedcount++
        })
        if(checkedcount===0) {
          item.isChecked= false
          item.isIndeterminate = false
        }else if(checkedcount===item[nextList].length&&indeterminateCount===0){
          item.isChecked= true
          item.isIndeterminate = false
        }else {
          item.isChecked= true
          item.isIndeterminate = true
        }
      }
      if(type==='init'){
        return {
          isChecked:item.isChecked,
          isIndeterminate:item.isIndeterminate
        }
      }
      this.getIndeterminateStyle(this.focusStyle,'themeLevels')
    },
    getIndeterminateStyle(item,nextList,type){
      let checkedcount = 0
      let indeterminateCount = 0
      if(item[nextList]&&item[nextList].length>0){
          item[nextList].forEach(style=>{
            if(style.isChecked&&style.isIndeterminate) indeterminateCount++
            if(style.isChecked) checkedcount++
          })
          if(checkedcount===0) {
            item.isChecked= false
            item.isIndeterminate = false
          }else if(checkedcount===item[nextList].length&&indeterminateCount===0){
            item.isChecked= true
            item.isIndeterminate = false
          }else {
            item.isChecked= true
            item.isIndeterminate = true
          }
      }
      if(type==='init'){
        return {
          isChecked:item.isChecked,
          isIndeterminate:item.isIndeterminate
        }
      }
      this.getIndeterminateChannel(this.focusChannel,'themeStyles')
    },
    getIndeterminateChannel(item,nextList){
      let checkedcount = 0
      let indeterminateCount = 0
      if(item[nextList]&&item[nextList].length>0){
          item[nextList].forEach(style=>{
            if(style.isChecked&&style.isIndeterminate) indeterminateCount++
            if(style.isChecked) checkedcount++
          })
          if(checkedcount===0) {
            item.isChecked= false
            item.isIndeterminate = false
          }else if(checkedcount===item[nextList].length&&indeterminateCount===0){
            item.isChecked= true
            item.isIndeterminate = false
          }else {
            item.isChecked= true
            item.isIndeterminate = true
          }
      }
      return {
        isChecked:item.isChecked,
        isIndeterminate:item.isIndeterminate
      }
    },
    handleConnectPODialogClose(){
      this.connetPODialog = false
    },
    getName(str){
      if(str){
          return str.split('|')[0] || str
      }else return ''
    },
    handleSubmit(){
      const result = []
      this.mappingList.forEach(channel=>{
        let channelData = Object.assign({},channel)
        channelData.themeStyles = []
        channel.themeStyles.forEach(style=>{
          let styleData = Object.assign({},style)
          if(style.themeLevels&&style.themeLevels.length>0){
            styleData.themeLevels = []
            style.themeLevels.forEach(level=>{
              let levelData = Object.assign({},level)
              levelData.mappingBuList = []
              level.mappingBuList.forEach(bu=>{
                let buData = Object.assign({},bu)
                buData.mappingRegionList = []
                bu.mappingRegionList.forEach(region=>{
                  region.isChecked?buData.mappingRegionList.push(region):''
                })
                bu.isChecked?levelData.mappingBuList.push(buData):''
              })
              level.isChecked?styleData.themeLevels.push(levelData):''
            })
            style.isChecked?channelData.themeStyles.push(styleData):''
          }else {
            styleData.mappingBuList = []
            style.mappingBuList.forEach(bu=>{
              let buData = Object.assign({},bu)
              buData.mappingRegionList = []
              bu.mappingRegionList.forEach(region=>{
                region.isChecked?buData.mappingRegionList.push(region):''
              })
              bu.isChecked?styleData.mappingBuList.push(buData):''
            })
            style.isChecked?channelData.themeStyles.push(styleData):''
          }
        })
        channel.isChecked?result.push(channelData):''
      })
      this.handleChangePO(result)
    },
    async handleChangePO(result){
      this.loading = true
      let params = {
        themeId:this.themeId,
        vendorCode:this.vendorCode,
        themeChannelVOList:result
      }
      const { data } = await gameplanApi.getGameplanPRPOSaveOrUpdate(params);
      if (data.resultCode === "0") {
        this.$message.success("操作成功！")
        this.connetPODialog= false
        this.$emit('handleMappingSuccess')
      }
      this.loading = false
    },
  },
};
</script>

<style lang="scss" scoped>
::v-deep .el-checkbox{
  width: max-content;
  padding-left: 10px;
}
::v-deep .el-checkbox__input.is-checked+.el-checkbox__label {
    color: #3a3a3a !important;
}
.focus-style{
  background-color:rgb(254, 244, 244);;
}
.display-flex{
  display:flex;
  //flex-direction:column;
  justify-content: space-between;
  cursor:pointer;
  text-align: center;
  line-height: 32px;
  align-items: center;
}
.icon-style{
  padding-right: 10px;
  width: 100%;
  text-align: end;
  line-height: 30px;
}
.select-item-box{
  display:flex;
  border: 1px solid #ececec;
  border-radius: 8px;
  width: fit-content;
  min-width: 500px;
  min-height: 40vh;
  overflow-y: auto;
  // flex-direction:column;
  // position:relative;
}
.select-item{
  border-right: 1px solid #ececec;
}
.select-item-line{
  min-width:200px;
  width: 20%;
}
.select-item-line-level{
  min-width:150px;
  width: 15%;
}
.no-data{
  margin:60px auto;
}
</style>
